module.exports = __webpack_public_path__ + "img/what-we-sell_0002.b77830ca.jpg";